import React, { Component, PropTypes } from 'react';

export default class Label extends Component {
	static propTypes = {
		forAttr: PropTypes.string.isRequired,
		labelClass: PropTypes.string.isRequired,
		label: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.object
		]).isRequired,
		labelIsInvisible: PropTypes.bool,
		labelDecoratorClass: PropTypes.string,
		qaSelector: PropTypes.string,
		children: PropTypes.object
	};
	static defaultProps = {
		labelClass: 'dna-label',
		labelIsInvisible: false,
		labelDecoratorClass: ''
	};
	render() {
		const {
			forAttr,
			labelClass,
			labelDecoratorClass,
			labelIsInvisible,
			label,
			qaSelector,
			children
		} = this.props;

		return (
			<label
				data-qa={`${qaSelector}-label`}
				className={`${labelClass}${labelIsInvisible ? ' dna-invisible' : ''}${labelDecoratorClass ? ' ' + labelDecoratorClass : ''}`}
				htmlFor={forAttr}>
				{ label }
				{ children && children }
			</label>
		);
	}
}



// WEBPACK FOOTER //
// ../~/dna-form/components/label/Label.jsx